import {Box, Typography, Icon} from '@mui/material';
import {ReactComponent as CalendarIcon} from '@icons/calendar.svg';
import {ReactComponent as ArrowRightIcon} from '@icons/arrow-line-right.svg';
import {ReactComponent as ClockIcon} from '@icons/clock.svg';
import {BODY2, MERIDIEM_HOUR_FORMAT, MMM_D_YYYY} from '@/utils/constants';
import {auctionHeaderStyle} from './AuctionHeader.styles';
import dayjs from 'dayjs';
import {useAppSelector} from '@/store/hooks';
import {getCurrentEventSelector} from '@/store/organization-event';

const AuctionHeader = () => {
	const event = useAppSelector(getCurrentEventSelector);

	return (
		<Box sx={auctionHeaderStyle.wrapperHeader}>
			<Box sx={auctionHeaderStyle.headerItem}>
				<Typography variant={BODY2} sx={auctionHeaderStyle.data}>
					Auction start:
				</Typography>
				<Typography sx={auctionHeaderStyle.time}>
					<Typography variant={BODY2} sx={auctionHeaderStyle.alignWrapper}>
						<CalendarIcon />{' '}
						{dayjs(event?.isOnlineAuction ? event?.startAuctionData : event?.startData).format(MMM_D_YYYY)}
					</Typography>
					<Typography variant={BODY2} sx={auctionHeaderStyle.alignWrapper}>
						<ClockIcon />{' '}
						{dayjs(event?.isOnlineAuction ? event?.startAuctionData : event?.startData).format(MERIDIEM_HOUR_FORMAT)}
					</Typography>
				</Typography>
			</Box>

			<Icon sx={auctionHeaderStyle.icon}>
				<ArrowRightIcon />
			</Icon>

			<Box sx={auctionHeaderStyle.headerItem}>
				<Typography variant={BODY2} sx={auctionHeaderStyle.data}>
					Auction end:
				</Typography>
				<Typography sx={auctionHeaderStyle.time}>
					<Typography variant={BODY2} sx={auctionHeaderStyle.alignWrapper}>
						<CalendarIcon />
						{dayjs(event?.isOnlineAuction ? event?.endAuctionData : event?.endData).format(MMM_D_YYYY)}
					</Typography>
					<Typography variant={BODY2} sx={auctionHeaderStyle.alignWrapper}>
						<ClockIcon />
						{dayjs(event?.isOnlineAuction ? event?.endAuctionData : event?.endData).format(MERIDIEM_HOUR_FORMAT)}
					</Typography>
				</Typography>
			</Box>
		</Box>
	);
};

export default AuctionHeader;
